/**
 * Stable CSS class names for E2E — Schedule Groups (group users) page.
 */
export const GU = {
    page: 'group-users-page',
    loadingSection: 'group-users-page__loading-section',
    layout: 'group-users-page__layout',

    breadcrumbCol: 'group-users-page__breadcrumb-col',
    addUserCol: 'group-users-page__add-user-col',
    addUserButton: 'group-users-page-input--button-add-user',

    emptyText: 'group-users-page__empty-text',

    searchRow: 'group-users-page__search-row',
    searchInput: 'group-users-page-input__search-user',

    tableOuterPaper: 'group-users-page__table-outer-paper',
    tableContainer: 'group-users-page__table-container',
    table: 'group-users-page__table',
    tableHead: 'group-users-page__table-head',
    tableHeadRow: 'group-users-page__table-head-row',
    tableHeadCell: 'group-users-page__table-head-cell',
    tableBody: 'group-users-page__table-body',
    tableRow: 'group-users-page__table-row',
    tableCell: 'group-users-page__table-cell',
    tableCellUsername: 'group-users-page__table-cell--username',
    tableCellRemove: 'group-users-page__table-cell--remove',

    removeUserButton: 'group-users-page-input--button-remove-user',
    removeUserIcon: 'group-users-page__remove-user-icon',
} as const;

export const guCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

